import React from 'react';

interface ComingSoonProps {
  'data-testid'?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = (props) => {
  return (
    <div className="flex items-center justify-center bg-gray-50 p-6" {...props}>
      <div className='bg-white rounded-md shadow p-4 md:p-6 h-[700px] flex items-center justify-center'>
        <div className="text-center">
          <h1 className="text-2xl font-heading text-gray-800 mb-4">Coming Soon</h1>
          <p className="mt-4 text-gray-600">This page is currently under construction. Please check back later.</p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
